import { DiscountKind } from "../../common/discount-kind";

class InventoryDocumentItemDTO {
	public cnCode: string | null;
	public discountKind: DiscountKind;
	public discountValue: number;
	public no: number;
	public note: string | null;
	public pkwiu: string | null;
	public productId?: number | null;
	public productName: string | null;
	public quantity: number;
	public unitId: number;
    public barCode: string;
    public symbol: string;
	public vatRateId: number;
	public jpkVatProductGroup: string;
	public relatedCommercialItemsIds: number[];
	public uniqueKey: string;

	//adjustment
	public adjustedItemId?: number | null;
}

export class InventoryUpdateDocumentItemDTO extends InventoryDocumentItemDTO {
	public price: number;
}

export class InventoryGetDocumentItemDTO extends InventoryDocumentItemDTO {
	public id: number;
	public grossValueAfterDiscount: number;
	public grossValue: number;
	public netValueAfterDiscount: number;
	public netValue: number;
	public unitGrossPriceAfterDiscount: number;
	public unitGrossPrice: number;
	public unitNetPriceAfterDiscount: number;
	public unitNetPrice: number;
	public vatValueAfterDiscount: number;
	public vatValue: number;
	public inventoryTotalCost: number;
	public inventoryUnitCost: number;
}
